export default {
  name: 'Template Helper',
  data() {
    return {};
  },
  methods: {
    prepareExecutionObject() {
      this.executionValues = [];
      this.fieldsData.forEach((fd) => {
        if (fd.input_type === 'FORMULA') {
          const selectedFields = (fd.selected_fields || [])
            .filter((e) => e.type === 'FIELD')
            .map((e) => e.key);

          this.executionValues.push({
            type: 'FORMULA',
            values: selectedFields,
          });
        }
      });
    },
    getChangedKeys(form1, form2) {
      const changedKeys = [];

      const allKeys = new Set([...Object.keys(form1), ...Object.keys(form2)]);

      allKeys.forEach((key) => {
        if (
          (!(key in form1) && form2[key]) ||
          (!(key in form2) && form1[key]) ||
          form1[key] !== form2[key]
        ) {
          changedKeys.push(key);
        }
      });

      return changedKeys;
    },

    prepareExecutionFormRulesObject() {
      this.formRulesDependentFields = this.fieldsData
        .filter(
          (fd) =>
            this.templateRules.filter(
              (rule) =>
                rule.conditions.filter((cond) => cond.selectField == fd.key).length ||
                rule.actions.filter((act) => act.value == fd.key && act.data_source == 'TEMPLATE')
                  .length
            ).length
        )
        .map((fd) => fd.key);
    },
    checkHasDuplicateChildTable(fields, data, previous_data) {
      const autoFillGroups = {};
      fields.forEach((field) => {
        if (
          field.data_table_field_auto_fill &&
          field.selected_auto_fill_entity &&
          (!field.filters || field.filters.length === 0) &&
          (!field.selected_fields || field.selected_fields.length === 0)
        ) {
          const entity = field.selected_auto_fill_entity;
          if (!autoFillGroups[entity]) autoFillGroups[entity] = [];
          autoFillGroups[entity].push(field.key);
        }
      });

      Object.entries(autoFillGroups).forEach(([, fieldKeys]) => {
        if (fieldKeys.length < 2) return;

        // Step 3: Collect current & previous rows
        const tables = fieldKeys.map((key) => ({
          key,
          current: data[key] || [],
          previous: (previous_data && previous_data[key]) || [],
        }));

        // Step 4: Merge rows by _id
        const mergedRows = {};
        tables.forEach(({ key, current, previous }) => {
          [...current, ...previous].forEach((row) => {
            if (!row._id) return; // skip rows without _id
            if (!mergedRows[row._id]) mergedRows[row._id] = {};
            mergedRows[row._id][key] = {
              current: row,
              previous: previous.find((r) => r._id === row._id),
            };
          });
        });

        // Step 5: Sync per rowId
        Object.entries(mergedRows).forEach(([rowId, rowGroup]) => {
          const keys = Object.keys(rowGroup);
          if (keys.length < 2) return;

          let sourceKey = null;
          let sourceRow = null;

          // Find the most recently changed row
          keys.forEach((k) => {
            const { current, previous } = rowGroup[k];
            const changed =
              !previous ||
              Object.keys(current).some((fieldName) => {
                if (fieldName === '_id' || fieldName === 'keyIndex') return false;
                return current[fieldName] !== previous[fieldName];
              });
            if (changed) {
              sourceKey = k;
              sourceRow = current;
            }
          });

          // If no changes found, skip
          if (!sourceRow) return;

          // Sync sourceRow into all other tables
          keys.forEach((k) => {
            if (k === sourceKey) return;
            const { current } = rowGroup[k];

            const hasDiff = Object.keys(sourceRow).some((fieldName) => {
              if (fieldName === '_id' || fieldName === 'keyIndex') return false;
              return sourceRow[fieldName] !== current[fieldName];
            });

            if (hasDiff) {
              Object.keys(sourceRow).forEach((fieldName) => {
                if (fieldName === '_id' || fieldName === 'keyIndex') return;
                current[fieldName] = sourceRow[fieldName];
              });

              // Write back updated row
              const targetIndex = data[k].findIndex((r) => r._id === rowId);
              if (targetIndex > -1) {
                data[k][targetIndex] = { ...current };
              }
            }
          });
        });
      });

      return data;
    },
  },
};
